// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/WorkingTimeModelSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/WorkingTimeModelSortBy.proto.
 */
export const file_Enumerations_WorkingTimeModelSortBy: GenFile = /*@__PURE__*/
  fileDesc("CilFbnVtZXJhdGlvbnMvV29ya2luZ1RpbWVNb2RlbFNvcnRCeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMq8AUKFldvcmtpbmdUaW1lTW9kZWxTb3J0QnkSKgomV09SS0lOR19USU1FX01PREVMX1NPUlRfQllfVU5TUEVDSUZJRUQQABIwCiRXT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9URU5BTlRfSUQQAxoGysfNDwEDEisKH1dPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX05BTUUQBBoGysfNDwEEEjkKLVdPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX05PX1RSQUNLSU5HX0JFRk9SRRAGGgbKx80PAQYSOAosV09SS0lOR19USU1FX01PREVMX1NPUlRfQllfTk9fVFJBQ0tJTkdfQUZURVIQBxoGysfNDwEHEjIKJldPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX1BBVVNFX0FGVEVSEAgaBsrHzQ8BCBI1CilXT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9QQVVTRV9EVVJBVElPThAJGgbKx80PAQkSQAo0V09SS0lOR19USU1FX01PREVMX1NPUlRfQllfTUFYSU1VTV9XT1JLX1RJTUVfUEVSX0RBWRAKGgbKx80PAQoSQgo2V09SS0lOR19USU1FX01PREVMX1NPUlRfQllfQUxMT1dfT1ZFUkxBUFBJTkdfVFJBQ0tJTkdTEAsaBsrHzQ8BCxIwCiRXT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9EQVlfQ09VTlQQDBoGysfNDwEMEjIKJVdPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX0NSRUFURURfQVQQZBoHysfNDwJkARIzCiZXT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9NT0RJRklFRF9BVBBlGgfKx80PAmQCEjIKJVdPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX0RFTEVURURfQVQQZhoHysfNDwJkAyIECAEQASIECAIQAiIECAUQBSIECA0QY0IoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort working time models by.
 *
 * @generated from enum time_tracking.enumerations.WorkingTimeModelSortBy
 */
export enum WorkingTimeModelSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the working time models by their tenant id.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the working time models by their name.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_NAME = 4;
   */
  NAME = 4,

  /**
   * Sort the working time models by their start time.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_NO_TRACKING_BEFORE = 6;
   */
  NO_TRACKING_BEFORE = 6,

  /**
   * Sort the working time models by their end time.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_NO_TRACKING_AFTER = 7;
   */
  NO_TRACKING_AFTER = 7,

  /**
   * Sort the working time models by the amount of trackings allowed before a forced pause.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_PAUSE_AFTER = 8;
   */
  PAUSE_AFTER = 8,

  /**
   * Sort the working time models by the minimum length of a required pause.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_PAUSE_DURATION = 9;
   */
  PAUSE_DURATION = 9,

  /**
   * Sort the working time models by the maximum allowed duration of trackings in a single day.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_MAXIMUM_WORK_TIME_PER_DAY = 10;
   */
  MAXIMUM_WORK_TIME_PER_DAY = 10,

  /**
   * Sort the working time models by whether overlapping trackings between projects are allowed.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_ALLOW_OVERLAPPING_TRACKINGS = 11;
   */
  ALLOW_OVERLAPPING_TRACKINGS = 11,

  /**
   * Sort the working time models by the number of days that have been declared for them.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_DAY_COUNT = 12;
   */
  DAY_COUNT = 12,

  /**
   * Sort the working time models by their creation time stamp.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the working time models by their modification time stamp.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the working time models by their deletion time stamp.
   *
   * @generated from enum value: WORKING_TIME_MODEL_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.WorkingTimeModelSortBy.
 */
export const WorkingTimeModelSortBySchema: GenEnum<WorkingTimeModelSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_WorkingTimeModelSortBy, 0);

